import React, { useContext, useState } from 'react';
import { Button, Col, Divider, Form, Input, Radio, Row } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import tokens from '../../../../../../../../../../utils/tokens';
import AloneCol from '../../../../../../../../../../components/common/AloneCol';
import DeleteButton from '../../../../../../../../../../components/common/buttons/DeleteButton';
import InputRut from '../../../../../../../../../../components/form/inputs/InputRut';
import IdentificationType from '../../../../../../../../../../enums/identificationType';
import Paragraph from '../../../../../../../../../../components/common/Paragraph';
import { EnrollmentFormContext } from '../../../../../../../../../../providers/EnrollmentFormContextProvider';
import { rutValidator } from '../../../../../../../../../../utils/validators';

const UafLegalStructureForm = ({ gutter }) => {
  const { enrollmentForm } = useContext(EnrollmentFormContext);
  const [selectedRut, setSelectedRut] = useState([]);

  const toggleRutCheck = (key) => {
    const arr = [...selectedRut];
    arr[key] = true;
    setSelectedRut(arr);

    const formValues = enrollmentForm.getFieldsValue(true);
    Object.assign(formValues.legalStructurePeople[key], {
      identification: '',
      identificationType: IdentificationType.RUT,
    });
    enrollmentForm.setFieldsValue(formValues);
  };

  const togglePassportCheck = (key) => {
    const arr = [...selectedRut];
    arr[key] = false;
    setSelectedRut(arr);
    const formValues = enrollmentForm.getFieldsValue(true);
    Object.assign(formValues.legalStructurePeople[key], {
      identification: '',
      identificationType: IdentificationType.PASAPORTE,
    });
    enrollmentForm.setFieldsValue(formValues);
    enrollmentForm.validateFields([['legalStructurePeople', key, 'identification']]);
  };
  // TODO: Eliminar si hay datos precargados
  const initialValues = {
    legalStructurePeople: [{}],
  };

  return (
    <>
      <Row justify="start" gutter={[gutter]}>
        <Col span={24}>
          <Paragraph noBottomMargin strong>
            Identifique la Alta Gerencia o Estructura Jurídica{' '}
            <InfoCircleOutlined style={{ color: '#B22938' }} />
          </Paragraph>
        </Col>
      </Row>
      {/* falta el formulario */}

      <Form form={enrollmentForm} layout="vertical" initialValues={initialValues}>
        <Form.List name="legalStructurePeople">
          {(fields, { add, remove }) => (
            <Row gutter={[tokens.forms.horizontalGutterInPx]}>
              {fields.map(({ key, name, fieldKey, ...restField }, fieldIndex) => (
                <React.Fragment key={key}>
                  {fieldIndex > 0 && (
                    <Col span={24}>
                      <Divider />
                    </Col>
                  )}
                  <AloneCol lg={12} xs={24}>
                    <Form.Item
                      name={[name, 'identificationType']}
                      rules={[{ required: true }]}
                      {...restField}
                    >
                      <Radio.Group defaultValue={1}>
                        <Radio value={IdentificationType.RUT} onChange={() => toggleRutCheck(key)}>
                          Rut
                        </Radio>
                        <Radio
                          value={IdentificationType.PASAPORTE}
                          onChange={() => togglePassportCheck(key)}
                        >
                          Pasaporte
                        </Radio>
                        <Radio
                          value={IdentificationType.OTRO}
                          onChange={() => togglePassportCheck(key)}
                        >
                          Otro
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  </AloneCol>
                  <AloneCol lg={12} xs={24}>
                    <Form.Item shouldUpdate noStyle>
                      {() => (
                        <Form.Item
                          label="N° de Identificación"
                          name={[name, 'identification']}
                          fieldKey={[fieldKey, 'identification']}
                          rules={[
                            {
                              required: true,
                              message: 'Identificador Requerido',
                            },
                            {
                              validator: selectedRut[key] ? rutValidator : undefined,
                              message: 'Rut invalido ',
                            },
                          ]}
                        >
                          {selectedRut[key] ? <InputRut /> : <Input type="text" maxLength={12} />}
                        </Form.Item>
                      )}
                    </Form.Item>
                  </AloneCol>
                  <AloneCol span={24}>
                    <Form.Item
                      label="Nombre"
                      name={[name, 'name']}
                      rules={[{ required: true, message: 'Dato requerido' }]}
                      {...restField}
                    >
                      <Input />
                    </Form.Item>
                  </AloneCol>
                  <AloneCol lg={12} xs={24}>
                    <Form.Item
                      label="Apellido Paterno"
                      name={[name, 'firstSurname']}
                      rules={[{ required: true, message: 'Dato requerido' }]}
                      {...restField}
                    >
                      <Input />
                    </Form.Item>
                  </AloneCol>
                  <AloneCol lg={12} xs={24}>
                    <Form.Item
                      label="Apellido Materno"
                      name={[name, 'secondSurname']}
                      rules={[{ required: false }]}
                      {...restField}
                    >
                      <Input />
                    </Form.Item>
                  </AloneCol>
                  <AloneCol lg={12} xs={24}>
                    <Form.Item
                      label="Cargo"
                      name={[name, 'position']}
                      rules={[{ required: true, message: 'Dato requerido' }]}
                      {...restField}
                    >
                      <Input />
                    </Form.Item>
                  </AloneCol>
                  {fields.length > 1 && (
                    <AloneCol lg={12} xs={24}>
                      <Form.Item>
                        <DeleteButton block onClick={() => remove(name)}>
                          Eliminar Persona
                        </DeleteButton>
                      </Form.Item>
                    </AloneCol>
                  )}
                </React.Fragment>
              ))}
              <AloneCol lg={12} xs={24}>
                <Form.Item>
                  <Button type="dashed" block onClick={() => add({})}>
                    + Agregar Persona
                  </Button>
                </Form.Item>
              </AloneCol>
            </Row>
          )}
        </Form.List>
      </Form>
    </>
  );
};

UafLegalStructureForm.propTypes = {
  gutter: PropTypes.number.isRequired,
};

export default UafLegalStructureForm;
